import { SavingLinkList } from '@components/saving-link-list/saving-link-list';

export const OverviewOfSavingInfoWidget = () => <SavingLinkList />;
